import { ChangeEvent, useState } from "react";
import { Button, Checkbox, Colors } from "@blueprintjs/core";
import { styled } from "styled-components";
import { Box, CustomCard } from "ui-components";
import useSession from "ui-io/use-session";
import InputField from "../input-field";
import { useNavigate } from "react-router-dom";
import { getEncryptedPassword, decodeJWT } from "../../../utils";
import {isValidEmail} from "ui-lib"
import {useMutation} from "react-query";
import { signInUser } from "ui-io/queries/users/sign-in-user";
import { Label } from "../../common";

const SignIn = () => {
  const { isAuthenticated, login } = useSession();
  const navigate = useNavigate();
  const [userDetail, setUserDetail] = useState({
    isLoggedIn: false,
    username: "",
    email: "",
    name: "",
    password: "",
  });



  const [formError, setFormError] = useState<string | null >(null)
  const [emailError, setEmailError] = useState<string | null >(null)
  const [passwordError, setPasswordError] = useState<string | null >(null)
    const logInMutaion = useMutation(signInUser, {
          onSuccess: (responseData) => {
            const accessToken = responseData?.accessToken || responseData?.token;
            const refreshToken = responseData?.refreshToken || responseData?.refresh_token;
            const payload = accessToken ? decodeJWT(accessToken) : null;
            const safeUserId = responseData?.userId || payload?.userId || payload?.id || "";
            const safeEmail = responseData?.email || payload?.email || userDetail.username.trim();
            const safeName = responseData?.name || payload?.name || userDetail.name.trim();
            const safeUsername = responseData.username || payload?.username || responseData?.email || safeEmail;
            const expiresAt = payload?.exp ? payload.exp * 1000 : undefined;

            if (accessToken && login) {
              login({
                token: accessToken,
                refreshToken,
                userId: safeUserId,
                username: safeUsername || "",
                email: safeEmail || "",
                name: safeName || "",
                expiresAt,
                role: (responseData?.roleInFirm || payload?.roleInFirm || undefined) as any,
                isAuthenticated: true,
                rememberMe: userDetail.isLoggedIn,
              });
              navigate("/dashboard");
            } else {
              setFormError("Login succeeded but no access token was returned.");
            }
          },
          onError: ()=>{
            setFormError("Invalid credentials or something went wrong.");
          },
    });

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, type, checked, value } = event.target;
    const userObj: any = { ...userDetail };

    if (name) {
      userObj[name] = type === "checkbox" ? checked : value;
    }

    setUserDetail({ ...userObj });

    if (name === "username") {
      if (!isValidEmail(value)) {
        setEmailError("Please enter a valid email address.");
      } else {
        setEmailError(null);
      }
    }

    if (name === "password") {
      if (value.length < 8) {
        setPasswordError("Password must be at least 8 characters.");
      } else {
        setPasswordError(null);
      }
    }
  };

  const onSubmitLogin = () => {
    try {
      const username = userDetail.username.trim();
      const password = userDetail.password.trim();

      if (!username || !password) {
        setFormError("Please enter your email and password.");
        return;
      }

      if (!isValidEmail(username)) {
        setFormError("Please enter a valid email address.");
        return;
      }

      const hashedPass = getEncryptedPassword({ password });
      const loginObject = {
        username,
        password: hashedPass,
      };

      setFormError(null);
      logInMutaion.mutate(loginObject);
    } catch (err: any) {
      setFormError("Login failed. Please try again.");
    }
  };

//   {
//     "responseData": {
//         "user": {
//             "mfa": {
//                 "isEnabled": false,
//                 "secret": null,
//                 "backupCodes": []
//             },
//             "mandateFilters": {
//                 "sectors": [],
//                 "geographies": [],
//                 "stages": [],
//                 "minSignalMatch": 80
//             },
//             "quotas": {
//                 "memosGeneratedThisMonth": 0,
//                 "maxMemosAllowed": 5,
//                 "companiesTrackedCount": 0,
//                 "maxCompaniesTracked": 100
//             },
//             "integrations": {
//                 "crm": {
//                     "provider": "none",
//                     "isConnected": false,
//                     "encryptedApiKey": null
//                 },
//                 "calendar": {
//                     "provider": "none",
//                     "refreshToken": null
//                 }
//             },
//             "_id": "6ad3b2ae892556b776f743b0",
//             "userId": "user_1792258734480_27ukx9sj",
//             "username": "rahulcoudh",
//             "email": "rahulcoudh@gmail.com",
//             "name": "Rahul K",
//             "organizationId": null,
//             "roleInFirm": "Analyst",
//             "isEmailVerified": false,
//             "stripeCustomerId": null,
//             "stripeSubscriptionId": null,
//             "subscriptionTier": "free",
//             "subscriptionStatus": "none",
//             "currentPeriodEnd": null,
//             "addedOn": 1792258734480,
//             "modifiedOn": 1792258734480,
//             "isDeleted": false,
//             "isInActive": false,
//             "savedLists": [],
//             "verifiedSignalsLog": [],
//             "__v": 0
//         },
//         "accessToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJ1c2VyXzE3OTIyNTg3MzQ0ODBfMjd1a3g5c2oiLCJlbWFpbCI6InJhaHVsY291ZGhAZ21haWwuY29tIiwidGllciI6ImZyZWUiLCJpYXQiOjE3OTIyNTg5NzQsImV4cCI6MTc5MjI1OTg3NH0.Wf8Mm61dfTHzvB78QRijdOUQJmdMkj5rdQoccOIp8So",
//         "refreshToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJ1c2VyXzE3OTIyNTg3MzQ0ODBfMjd1a3g5c2oiLCJpYXQiOjE3OTIyNTg5NzQsImV4cCI6MTc5Mjg2Mzc3NH0.rJa-klRD9fpVHJxWRTuNOMpEN9nOMhyVseY6v7ggeR8"
//     },
//     "message": "Get Successfully",
//     "success": true,
//     "responseCode": 200
// }

  return (
    <Box flexDir="row" justify="between"  mt={"large"} items="center" height={"1"}>
      <Box width={"1/2"}>
        <BannerContent> The startup discovery engine</BannerContent>
        <BannerContent isDark={true}> Find your fund returners</BannerContent>
        <img
          src="/images/login-banner.svg"
          alt="Login Banner"
          className="mt-xxlg"
        />
      </Box>
    
        <CustomCard maxWidth="400px" marginTop="0px">
          <div className="pt-xxlg pb-xxlg pl-md pr-md mt-md mb-md">
            <div className="fs-26 fw-bold">Sign In</div>
            <div className="mt-md fs-13">
              Enter your email and password to sign in!
            </div>

            <InputField
              label={"Email"}
              name={"username"}
              type={"text"}
              placeholder="mail@simple.com"
              onChange={handleOnChange}
              value={userDetail?.username ?? ""}
            />

            <InputField
              label={"Password"}
              name={"password"}
              type={"password"}
              placeholder="Min. 8 characters"
              onChange={handleOnChange}
              value={userDetail?.password ?? ""}
            />

            <div className="mt-lg fs-10 display-flex justify-between">
              <Checkbox
                name="isLoggedIn"
                checked={userDetail.isLoggedIn}
                label="Keep me logged in"
                onChange={handleOnChange}
              />
              <a>Forgot password?</a>
            </div>
            <Button className="w-100" onClick={onSubmitLogin}>
              Sign In
            </Button>
            {passwordError ? (
              <Box className="mt-sm mb-sm">
                <Label className="text-danger fs-10">{passwordError}</Label>
              </Box>
            ): formError && (
              <Box className="mt-sm mb-sm">
                <Label className="text-danger fs-10">{formError}</Label>
              </Box>
            )}
            <div className="display-flex align-center mt-md mb-md"><CustomHr />&nbsp;Or&nbsp;<CustomHr/></div>
            <div className={"mt-sm mb-sm fs-10 display-flex justify-between"}>
              <span>continue with Google</span>{" "}
              <span>continue with Facebook</span>
            </div>
            <div className={"mt-md fs-13"}>
              <span>Click here to </span>
              <a
                className={"classes.haveAccountLogin"}
                onClick={() => {
                  navigate("/sign-up");
                }}
              >
                Create an account
              </a>
            </div>
          </div>
        </CustomCard>
    </Box>
  );
};
export default SignIn;

const BannerContent = styled.div<{ isDark?: boolean }>`
  font-size: 30px;
  font-weight: 600;
  line-height: 1.3em;
  color: ${({ isDark, theme: { darkMode } }) =>
    isDark
      ? darkMode
        ? Colors.LIGHT_GRAY5
        : Colors.BLACK
      : darkMode
        ? Colors.LIGHT_GRAY1
        : Colors.GRAY3};
`;
const CustomHr = styled.hr`
width: 100%;
    height: 1px;
`